<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    class="left-sidebar">
    <v-layout
      justify-center
      wrap>
        <v-flex
        md12>
        <v-card
        elevation="2"
        class="card-body">
        <v-card>
            <v-card-title>{{ $t('subcategories.editSubcategory')}} {{ getCategoryName }}</v-card-title>
        </v-card>
        <v-spacer/>
            <v-form ref="editSubcategoryForm">
              <v-card-text>
                  <v-container grid-list-md mt-12>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="categoryName"
                            :label="$t('subcategories.name')"
                            :placeholder="$t('subcategories.name')"
                            :error-messages="subcategoryNameErrors"
                          />
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-select
                            v-model="products"
                            :items="getAllProducts"
                            :label="$t('subcategories.products')"
                            :placeholder="$t('subcategories.products')"
                            item-text="title"
                            item-value="id"
                            multiple
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="sku"
                            :label="$t('subcategories.sku')"
                            :placeholder="$t('subcategories.sku')"
                            :error-messages="skuErrors"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="sortBoxNo"
                            :label="$t('subcategories.sortBoxNo')"
                            :placeholder="$t('subcategories.sortBoxNo')"
                            :error-messages="sortBoxNoErrors"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="metaTitle"
                            :label="$t('subcategories.metaTitle')"
                            :placeholder="$t('subcategories.metaTitle')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md9>
                        <v-text-field
                            v-model="metaDescription"
                            :label="$t('subcategories.metaDescription')"
                            :placeholder="$t('subcategories.metaDescription')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md6>
                        <v-text-field
                            v-model="metaKeywords"
                            :label="$t('subcategories.metaKeywords')"
                            :placeholder="$t('subcategories.metaKeywords')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md6>
                        <v-text-field
                            v-model="metaUrl"
                            :label="$t('subcategories.metaUrl')"
                            :placeholder="$t('subcategories.metaUrl')"
                          />
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                            v-model="metaImage"
                            :label="$t('subcategories.metaImage')"
                            :placeholder="$t('subcategories.metaImage')"
                          />
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                          <v-checkbox
                              v-model="isActiveWeb"
                              :label="$t('subcategories.web')"
                          ></v-checkbox>
                      </v-flex>
                       <v-flex xs12 sm6 md2>
                            <v-checkbox
                                v-model="isActiveMobile"
                                :label="$t('subcategories.mobile')"
                            ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                            <span>{{ $t('subcategories.image') }}</span><br><br>
                            <div class="img-wrapper">
                              <i class="mdi mdi-delete delete delete-sign-category image"  title="delete" @click="removeImage()"></i>
                              <!-- <span class="delete-sign image" @click="removeImage()"><span class="delete" title="delete">x</span></span> -->
                            <img id="subcategoryImage" class="uploaded-img">
                            </div><br><br>
                            <input @change="setEditImage()" id="subcategory-image-edit" type='file' accept="image/*"/>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                            <v-color-picker v-model="color"
                                    mode="hexa"
                                    hide-mode-switch></v-color-picker>
                            <!-- <span>{{ showColor }}</span> -->
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        class="add-new mb-1 mt-8 mr-3" dark
                        @click="cancelSubcategory()">{{ $t('cancel')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="add-new mb-1 mt-8 mr-3" dark
                        @click="deleteCategory()">{{ $t('delete')}}</v-btn>
                    <v-btn
                        class="add-new mb-1 mt-8 mr-3" dark
                        @click="editSubcategory()">{{ $t('submit')}}</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {  mapGetters } from 'vuex';
  import { required, numeric } from 'vuelidate/lib/validators'
  import i18n from '../../i18n'
  import axios from 'axios'
  import Vue from 'vue'
  export default {
      data () {
          return {
            categoryName: '',
            products: [],
            productsLength: null,
            sku: '',
            sortBoxNo: '',
            metaTitle: '',
            metaDescription: '',
            metaKeywords: '',
            metaUrl: '',
            metaImage: '',
            isActiveWeb: false,
            isActiveMobile: false,
            urlSubcategoryId: null,
            type: 'hex',
            hex: '#FF00FF',
            rmImage: false,
          }
      },
      validations: {
          categoryName: { required },
          sku: { required },
          sortBoxNo: { required, numeric }
      },
      computed: {
        ...mapGetters([
            'getAllProducts',
            'getCategory',
            'getCategoryName',
            'getCategoryTranslations'
        ]),
        color: {
            get () {
                return this[this.type];
            },
            set (v) {
                    this[this.type] = v;
                },
        },
        showColor () {
            if (typeof this.color === 'string') return this.color

            return JSON.stringify(Object.keys(this.color).reduce((color, key) => {
                color[key] = Number(this.color[key].toFixed(2))
                return color
            }, {}), null, 2)
        },
        subcategoryNameErrors(){
            const errors = [];
                if (!this.$v.categoryName.$dirty) return errors;
                    !this.$v.categoryName.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        skuErrors(){
            const errors = [];
                if (!this.$v.sku.$dirty) return errors;
                    !this.$v.sku.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        sortBoxNoErrors(){
            const errors = [];
                if (!this.$v.sortBoxNo.$dirty) return errors;
                    !this.$v.sortBoxNo.numeric && errors.push(i18n.tc('fieldValueNumber'));
                    !this.$v.sortBoxNo.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        }
      },
      methods: {
        setEditImage(){
          const editImage = document.getElementById('subcategory-image-edit').files[0];
          let output = document.getElementById('subcategoryImage');
              output.src = URL.createObjectURL(editImage);

              output.onload = function() {
                  URL.revokeObjectURL(output.src)
              }
      },
        resetSubcategoryForm(){
            this.$refs.editSubcategoryForm.reset();
            this.$v.$reset();
        },
        cancelSubcategory(){
            this.resetSubcategoryForm();
            this.$router.go(-1);
        },
        editSubcategory(){
          const categoryFileEdit = document.getElementById('subcategory-image-edit').files[0],
                categoryId = this.urlSubcategoryId;

          let formData = new FormData();
              formData.append('categoryId', this.urlSubcategoryId);

              if (categoryFileEdit || this.rmImage) {
                  formData.append('image', categoryFileEdit || null);
              }
  
              let sku = localStorage.getItem('sku_subcategory')
                if(sku != this.sku){
                   formData.append('sku', this.sku);
              } 
              formData.append('position', this.sortBoxNo);
              formData.append('enable_mobile', this.isActiveMobile);
              formData.append('enable_web', this.isActiveWeb);
              formData.append('color', this.showColor);

              const translations = [
                {
                  'name': this.categoryName,
                  'meta_title': this.metaTitle,
                  'meta_description': this.metaDescription,
                  'meta_keywords': this.metaKeywords,
                  'meta_url': this.metaUrl,
                  'meta_image': this.metaImage,
                  'language_identifier': 'sr',
                }
              ]

              formData.append(
                  'translations', new Blob([JSON.stringify(translations)], {type: 'application/json'})
              )

              const productIds = this.products.length === this.productsLength
                  ? this.products.map(product => product.id)
                  : this.products;

              formData.append(
                  'product_ids', new Blob([JSON.stringify(productIds)],
                      {type: 'application/json'})
              )

            if(this.$v.categoryName.$invalid || this.$v.categoryName.$sku
                 || this.$v.sortBoxNo.$invalid){
                this.$v.$touch();
                return;
            } else {
              return new Promise((resolve) => {
                axios.put(`category/${categoryId}`, formData)
                  .then(resp => {
                    if(!resp.data.error){
                          Vue.toasted.show(i18n.tc(`successfully`),{
                              theme: 'outline',
                              singleton: true,
                              position:'top-center',
                              action :
                                {
                                    text : i18n.tc(`ok`),
                                    onClick : (e, toastObject) => {
                                        toastObject.goAway(0);
                                    }
                                }
                          });
                          this.$store.dispatch('LOAD_ALL_CATEGORIES')
                          this.resetSubcategoryForm();
                          localStorage.removeItem('sku_subcategory');
                          this.$router.go(-1);
                    } else {
                      console.log(resp.data.error)
                    }
                resolve(resp)
                })
              })
            }
        },
        deleteCategory(){
            if (confirm(i18n.t(`areYouSureToDelete`))) {
              this.$store.dispatch('DELETE_CATEGORY', this.$route.params.id)
                  .then(() => this.$store.dispatch('LOAD_ALL_CATEGORIES'));
                   this.$router.go(-1);
            }
        },
        removeImage(){
          if (confirm(i18n.t(`areYouSureToDelete`))) {
             document.getElementById('subcategoryImage').style.display = 'none';
                 document.querySelector('.delete-sign-category').remove();
                 this.rmImage = true;
          }
        },
      },
      beforeCreate() {
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
      },
      mounted() {
          this.urlSubcategoryId = this.$route.params.id;
          this.$store.dispatch('LOAD_ALL_PRODUCTS');

        this.$store.dispatch('GET_CATEGORY', this.urlSubcategoryId)
            .then(res => {
                let response = res.data.data;
                this.categoryName = response.name;
                this.products = response.products,
                this.productsLength = response.products.length,
                this.sku = response.sku,
                this.sortBoxNo = response.position,
                this.isActiveWeb = response.enable_web,
                this.isActiveMobile = response.enable_mobile,
                this.color = response.color,
                this.metaTitle = response.translations[0].meta_title,
                this.metaDescription = response.translations[0].meta_description,
                this.metaKeywords = response.translations[0].meta_keywords,
                this.metaUrl = response.translations[0].meta_url,
                this.metaImage = response.translations[0].meta_image,
                document.getElementById('subcategoryImage').src = response.image;
                localStorage.setItem('sku_subcategory', response.sku);
            })
      },
  }
</script>

<style lang="less">

</style>
